import Model, { attr } from '@ember-data/model';
import { resolveScreenshotUrl } from 'admin-panel/utils/resolve-screenshot-url';

export default class HomeScreenModel extends Model {
  @attr
  declare active?: boolean;

  @attr('number')
  declare deviceWidth?: number;

  @attr
  declare name: string;

  @attr('number')
  declare screenshotHeight?: number;

  @attr
  declare screenshotUrl?: string;

  @attr('number')
  declare screenshotWidth?: number;

  get resolvedScreenshotUrl() {
    return resolveScreenshotUrl(this.screenshotUrl);
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'home-screen': HomeScreenModel;
  }
}
